import { memo } from 'react';
import Rating from '@mui/material/Rating';

interface Props {
  value: number;
  precision?: number;
  size?: 'small' | 'large';
  isReadOnly?: boolean;
}

const Component = memo((props: Props) => {
  return (
    <Rating
      name="simple-controlled"
      value={props.value}
      precision={props.precision ?? 0.5}
      readOnly={props.isReadOnly}
      size={props.size}
    />
  );
});
export default Component;
